/**
 *  Date    : 2022/09/09
 *  Author  : lbb1811
 *  Declare : ShowToast
 *  在页面最外层组件中引入 `<ShowToast />`, 在此页面的其他地方调用`Toast({ title: '操作成功' })`
 */

import React, { useEffect, useState } from 'react';

import { EventEmitter } from '@/utils/eventEmitter';
import { TOAST_CANLE_IMG, TOAST_SUCCESS_IMG } from '@/constants/common';
import ToastModal from './ToastModal';

const eventEmitter = new EventEmitter();
const eventName = 'CUSTOM_SHOW_TOAST';
const ICON_URLS = {
  success: TOAST_SUCCESS_IMG,
  warning: TOAST_CANLE_IMG
};

export default function ShowToast() {

  const [toastInfo, setToastInfo] = useState({});

  useEffect(() => {
    eventEmitter.on(eventName, handleShowInfo);
  }, []);

  function handleShowInfo(options = {}) {
    setToastInfo({
      ...options,
      show: true
    });
  }

  function onClose() {
    setToastInfo({});
  }

  return (
    <ToastModal
      isShowToast={!!toastInfo.show}
      iconUrl={toastInfo.iconUrl || (toastInfo.type === 'none' ? '' : ICON_URLS[toastInfo.type || 'success'])}
      content={toastInfo.title}
      closeToast={onClose}
      top={toastInfo.top}
      left={toastInfo.left}
    />
  );
}

/**
 * 自定义 toast
 * @param {String} title 文案
 * @param {String} type `'success' | 'warning' | 'none'` 图标 (默认为`success`)
 * @param {String} iconUrl icon链接（优先取iconUrl，其次是type）
 *
 * ```js
 * // 参数 title, iconUrl, type, duration, top, left
 *    Toast({ title: '操作成功', type: 'success' });
 * ```
 */

export function CustomToast(options) {
  if(Object.prototype.toString.call(options) !== '[object Object]') {
    return console.warn('Toast error: 参数必须为Object');
  }
  eventEmitter.trigger(eventName, options);
}